<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item>
                  <el-select
                    v-model="form.company_bank"
                    placeholder="转账银行"
                    style="width: 150px"
                    clearable
                  >
                    <el-option label="中国银行" value="中国银行"></el-option>
                    <el-option label="招商银行" value="招商银行"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.pay_admin"
                    placeholder="转账人"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.obssid"
                    placeholder="银行流水号"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.type_id"
                    placeholder="单号"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.order_type"
                    placeholder="转账类型"
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="(item, index) in resData.type_op"
                      :key="index"
                      :label="item"
                      :value="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.pay_status"
                    placeholder="转账状态"
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="(item, index) in resData.status_op"
                      :key="index"
                      :label="item"
                      :value="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="转账日期：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <!--<el-form-item>-->
                <!--<el-button type="" @click="reset">重置</el-button>-->
                <!--</el-form-item>-->
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-button
            slot="trigger"
            style="margin-left: auto"
            size="mini"
            type="success"
            @click="exportExcel"
            >导出</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            :cell-class-name="addColor"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              prop="company_bank"
              label="转账银行"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="company_bank_account"
              label="转账银行账号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="obssid"
              label="银行流水号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pay_order_order_type"
              label="转账类型"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="type_id"
              label="单号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="admin_name"
              label="转账人"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="pay_contact"
              label="收款人"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="pay_account"
              label="收款人银行账号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pay_bank"
              label="收款人银行名称"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="total"
              label="转账金额"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pay_order_pay_status"
              label="状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="furinfo"
              label="用途"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="remark"
              label="备注"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="转账日期"
            ></el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.count"
            :page-size="form.pagesize"
            :page-sizes="[50, 100, 200, 500, 1000]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: {},
      form: {
        pagesize: 100,
      },
      loading: false,
      tableLoading: false,
      url: "/erp/payOrder/lst",
      curPage: 1,
      filterFold: false,
      isAll: false,
      supplyData: null,
      logcurPage: 1,
      logInfo: {},
      multipleSelection: [],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    addColor({ row, column, columnIndex }) {
      // if (columnIndex === 15) {
      //     return 'blue-cell';
      // }
    },
    exportExcel() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      for (const key in val) {
        multipleSelection[key] = val[key].work_id;
      }
      this.multipleSelection = multipleSelection;
    },

    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSizeChange(val) {
      this.form.pagesize = val;
      this.fetchData(true);
    },

    search() {
      this.form.page = 1;
      this.loading = true;
      this.fetchData(true);
    },

    trim(str, is_global) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    reset() {
      this.search_value = "";
      this.form = {};
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/payorder/PayOrderList.vue